import { AfterViewInit, Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { ChartSpecification } from '../../../../dataModels/chart-data-model';

declare var AmCharts;

@Component({
    selector: 'new-multiple-line-chart',
    templateUrl: 'multiple-line-chart.component.html',
    styleUrls: ['multiple-line-chart.component.css', '../../charts.style.scss']
})

export class NewMultipleLineChartComponent implements OnInit, AfterViewInit {
    @Input() chartSpecification: ChartSpecification;
    @Output() ClickEvent = new EventEmitter<string>();
    chart: any;

    constructor() {
    }

    ngOnInit() {
        this.chartSpecification.title = this.chartSpecification.title || "";
        this.chartSpecification.theme = this.chartSpecification.theme || "none";
        this.chartSpecification.chartColor = this.chartSpecification.chartColor || "";
        this.chartSpecification.data = this.chartSpecification.data || [];
        this.chartSpecification.yAxisTitle = this.chartSpecification.yAxisTitle || "";
        this.chartSpecification.xAxis = this.chartSpecification.xAxis || "xAxis";
        this.chartSpecification.yAxis = this.chartSpecification.yAxis || "yAxis";
        this.chartSpecification.divId = this.chartSpecification.divId || "multiDiv";
        this.chartSpecification.graphs = this.chartSpecification.graphs || [];
        this.chartSpecification.categoryGridThickness = this.chartSpecification.categoryGridThickness || 0;
        this.chartSpecification.precision = this.chartSpecification.precision || 0;
        this.chartSpecification.valueAxesCount = this.chartSpecification.valueAxesCount || this.chartSpecification.graphs.length;
        this.chartSpecification.EnableExport = (this.chartSpecification.EnableExport != null ? this.chartSpecification.EnableExport : true)
        this.chartSpecification.OnClickEvent = (this.chartSpecification.OnClickEvent != null ? this.chartSpecification.OnClickEvent : null)
        if (typeof this.chartSpecification.parseDates === "undefined") {
            this.chartSpecification.parseDates = true;
        }
        
    }

    ngAfterViewInit() {
        this.drawChart();
    }
  
    drawChart() {
        setTimeout(() => {
            this.chart = AmCharts.makeChart(this.chartSpecification.divId, {
                "hideCredits": true,
                "type": "serial",
                "theme": this.chartSpecification.theme,
                "mouseWheelZoomEnabled": false,
                "titles": [{
                    "size": 12,
                    "text": this.chartSpecification.title
                }],
                "legend": {
                    "useGraphSettings": true,
                    "valueText": ""
                },
                "dataProvider": this.chartSpecification.data,
                "synchronizeGrid": true,
                "valueAxes": this.getCharts(),
                "graphs": this.getGraphs(),
                "chartScrollbar": {
                    "offset": 30,
                    "oppositeAxis": false
                },
                "chartCursor": {
                    "cursorPosition": "mouse"
                },
                "categoryField": this.chartSpecification.xAxis,
                "categoryAxis": {
                    "parseDates": this.chartSpecification.parseDates,
                    "axisColor": "#DADADA",
                    "minorGridEnabled": true,
                    "gridThickness": this.chartSpecification.categoryGridThickness
                },
                "export": {
                    "enabled": this.chartSpecification.EnableExport,
                    "fileName": this.chartSpecification.title
                }
            });
            if (this.ClickEvent != null)
                this.chart.addListener("clickGraphItem", (e) => this.ClickEvent.next(e));

        
        }, 20);
       
    }

    getGraphs() {
        let graphs: any[] = [];

        this.chartSpecification.graphs.forEach((item, index) => {
            graphs.push({
                "valueAxis": "v" + (this.chartSpecification.valueAxesCount === this.chartSpecification.graphs.length ? index + 1 : this.chartSpecification.valueAxesCount),
                "bullet": item.bullet || "round",
                "bulletBorderThickness": 2,
                "hideBulletsCount": 30,
                "title": item.title,
                "valueField": item.fieldName,
                "fillAlphas": 0,
                "lineThickness": 2,
                "balloonText": "<span style='font-weight: bolder;'>[[title]]: <b>[[value]]</b></span>",
                "lineColor": item.color || "",
                "precision": this.chartSpecification.precision
            });
        });

        return graphs;
    }

    getCharts() {
        let charts: any[] = [];
        let offset = 0;
        this.chartSpecification.graphs.forEach((item, index) => {
            if (index < this.chartSpecification.valueAxesCount) {
                charts.push({
                    "id": "v" + (index + 1),
                    "axisThickness": this.chartSpecification.showValueAxis ? 2 : 0,
                    "axisAlpha": this.chartSpecification.showValueAxis ? 1 : 0,
                    "axisColor": item.color,
                    "offset": offset,
                    "position": this.chartSpecification.showValueAxis && (index % 2) == 0 ? "left" : "right",
                    "labelsEnabled": this.chartSpecification.showValueAxis ? this.chartSpecification.showValueAxis : false
                });

                if (this.chartSpecification.showValueAxis && index > 0 && (index % 2) > 0)
                    offset += 50;
            }
        });

        return charts;
    }
}



// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/charts/lineCharts/multiple-line-chart/multiple-line-chart.component.ts